import { FC } from 'react';
import css from './index.module.scss';
import { bundleKey, bundleLink } from './const';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import EFArrowRight from '@/components/UI/svg/Icons/EFArrowRight';
import { saveAICookieForShopify } from 'eco-design-micro/common/CookieForShopify';
import gtm from '@/utils/gtm';

const img_spec: any = {
    us: '',
    cn: '_cn',
    jp: '_jp',
    uk: '_uk',
    eu: '_eu',
    de: '_eu',
    fr: '_eu',
    it: '_eu',
    es: '_eu',
    au: '_au',
};

const d2m220_spec: any = {
    us: 'd2m_2_220W_us',
    ca: 'd2m_2_220W_us',
    uk: 'd2m_2_220W_uk',
    eu: 'd2m_2_220W_uk',
    de: 'd2m_2_220W_de',
    fr: 'd2m_2_220W_fr',
    it: 'd2m_2_220W_it',
    es: 'd2m_2_220W_es',
    jp: 'd2m_2_220W_us',
    au: 'd2m_2_220W_au',
    ph: 'd2m_2_220W_uk',
};

const d2m400_spec: any = {
    us: 'd2m_400W_us',
    ca: 'd2m_400W_us',
    uk: 'd2m_400W_uk',
    eu: 'd2m_400W_uk',
    de: 'd2m_400W_de',
    fr: 'd2m_400W_fr',
    it: 'd2m_400W_it',
    es: 'd2m_400W_es',
    jp: 'd2m_400W_us',
    ph: 'd2m_400W_uk',
};

export const BundleList: FC<{ list: (keyof typeof bundleKey)[]; moreUrl: string; theme?: 'black' | 'grey' }> = (props) => {
    const theme = props.theme ?? 'black';
    const { isMobile, useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('shared.product');
    const { locale } = useRouter();
    const lists = isMobile ? props?.list?.slice(0, 2) : props?.list?.slice(0, 3);
    const bundleMap = {
        [bundleKey.wave2delta2]: {
            webp: require('@publicLocal/product-common/bundle-list/wave-2-delta-2.webp'),
            img: require('@publicLocal/product-common/bundle-list/wave-2-delta-2.png'),
            name: t('bundle_wave_delta'),
            // @ts-ignore
            link: bundleLink[bundleKey.wave2delta2][locale] || bundleLink[bundleKey.wave2delta2].us,
        },
        [bundleKey.wave2deltamax]: {
            webp: require('@publicLocal/product-common/bundle-list/wave-2-delta-max.webp'),
            img: require('@publicLocal/product-common/bundle-list/wave-2-delta-max.png'),
            name: t('bundle_wave_delta_max'),
            // @ts-ignore
            link: bundleLink[bundleKey.wave2deltamax][locale] || bundleLink[bundleKey.wave2deltamax].us,
        },
        [bundleKey.wave2deltapro]: {
            webp: require(`@publicLocal/product-common/bundle-list/wave-2-delta-pro${img_spec[locale] || img_spec.us}.png`),
            img: require(`@publicLocal/product-common/bundle-list/wave-2-delta-pro${img_spec[locale] || img_spec.us}.png`),
            name: t('bundle_wave_delta_pro'),
            // @ts-ignore
            link: bundleLink[bundleKey.wave2deltapro][locale] || bundleLink[bundleKey.wave2deltapro].us,
        },
        [bundleKey.wave2glacier]: {
            webp: require(`@publicLocal/product-common/bundle-list/wave-2-glacier${locale === 'au' ? '_au' : ''}.webp`),
            img: require(`@publicLocal/product-common/bundle-list/wave-2-glacier${locale === 'au' ? '_au' : ''}.png`),
            name: t('bundle_wave2_glacier'),
            // @ts-ignore
            link: bundleLink[bundleKey.wave2glacier][locale] || bundleLink[bundleKey.wave2glacier].us,
        },
        [bundleKey.glacierriver2pro]: {
            webp: require(`@publicLocal/product-common/bundle-list/${locale === 'au' ? 'glacier-river-2-pro_au.png' : 'glacier-river-2-pro.webp'}`),
            img: require(`@publicLocal/product-common/bundle-list/glacier-river-2-pro${locale === 'au' ? '_au' : ''}.png`),
            name: locale === 'br' ? 'Estação de Energia Portátil EcoFlow RIVER 2 Pro' : t('bundle_glacier_river_pro'),
            // @ts-ignore
            link: bundleLink[bundleKey.glacierriver2pro][locale] || bundleLink[bundleKey.glacierriver2pro].us,
        },
        [bundleKey.glacierriver2max]: {
            webp: require('@publicLocal/product-common/bundle-list/glacier-river-2-max.png'),
            img: require('@publicLocal/product-common/bundle-list/glacier-river-2-max.png'),
            name: t('bundle_glacier_river_2_max'),
            // @ts-ignore
            link: bundleLink[bundleKey.glacierriver2max][locale] || bundleLink[bundleKey.glacierriver2max].us,
        },
        [bundleKey.glacierdeltamax]: {
            webp: require('@publicLocal/product-common/bundle-list/glacier-delta-max.webp'),
            img: require('@publicLocal/product-common/bundle-list/glacier-delta-max.png'),
            name: t('bundle_glacier_delta_max'),
            // @ts-ignore
            link: bundleLink[bundleKey.glacierdeltamax][locale] || bundleLink[bundleKey.glacierdeltamax].us,
        },
        [bundleKey.glacierriversolar]: {
            webp: require(`@publicLocal/product-common/bundle-list/glacier-river-solar${locale === 'au' ? '_au.png' : '.webp'}`),
            img: require(`@publicLocal/product-common/bundle-list/glacier-river-solar${locale === 'au' ? '_au' : ''}.png`),
            name: t('bundle_glacier_river_solar'),
            // @ts-ignore
            link: bundleLink[bundleKey.glacierriversolar][locale] || bundleLink[bundleKey.glacierriversolar].us,
        },
        [bundleKey.bladelsk]: {
            webp: require('@publicLocal/product-common/bundle-list/blade-lsk.webp'),
            img: require('@publicLocal/product-common/bundle-list/blade-lsk.png'),
            name: t('bundle_blade_lsk'),
            // @ts-ignore
            link: bundleLink[bundleKey.bladelsk][locale] || bundleLink[bundleKey.bladelsk].eu,
        },
        [bundleKey.blade_seb_400psp]: {
            webp: require('@publicLocal/product-common/bundle-list/blade-seb-400p.webp'),
            img: require('@publicLocal/product-common/bundle-list/blade-seb-400p.png'),
            name: t('bundle_blade_lsk_se'),
            // @ts-ignore
            link: bundleLink[bundleKey.blade_seb_400psp][locale] || bundleLink[bundleKey.blade_seb_400psp].eu,
        },
        [bundleKey.blade_lsk_seb_400psp]: {
            webp: require('@publicLocal/product-common/bundle-list/blade-lsk-se.webp'),
            img: require('@publicLocal/product-common/bundle-list/blade-lsk-se.png'),
            name: t('bundle_blade_seb_400p'),
            // @ts-ignore
            link: bundleLink[bundleKey.blade_lsk_seb_400psp][locale] || bundleLink[bundleKey.blade_lsk_seb_400psp].eu,
        },
        [bundleKey.glacierEB]: {
            webp: require('@publicLocal/product-common/bundle-list/glacier_EB.webp'),
            img: require('@publicLocal/product-common/bundle-list/glacier_EB.png'),
            name: t('bundle_glacier_EB'),
            // @ts-ignore
            link: bundleLink[bundleKey.glacierEB][locale] || bundleLink[bundleKey.glacierEB].us,
        },
        [bundleKey.glacierEB110w]: {
            webp: require('@publicLocal/product-common/bundle-list/glacier_EB_110w.webp'),
            img: require('@publicLocal/product-common/bundle-list/glacier_EB_110w.png'),
            name: t('bundle_glacier_EB_110w'),
            // @ts-ignore
            link: bundleLink[bundleKey.glacierEB110w][locale] || bundleLink[bundleKey.glacierEB110w].us,
        },
        [bundleKey.wave2EB]: {
            webp: require('@publicLocal/product-common/bundle-list/wave2_EB.webp'),
            img: require('@publicLocal/product-common/bundle-list/wave2_EB.png'),
            name: t('bundle_wave2_EB'),
            // @ts-ignore
            link: bundleLink[bundleKey.wave2EB][locale] || bundleLink[bundleKey.wave2EB].us,
        },
        [bundleKey.wave2EB160w]: {
            webp: require('@publicLocal/product-common/bundle-list/wave2_EB_160w.webp'),
            img: require('@publicLocal/product-common/bundle-list/wave2_EB_160w.png'),
            name: t('bundle_wave2_EB_160w'),
            // @ts-ignore
            link: bundleLink[bundleKey.wave2EB160w][locale] || bundleLink[bundleKey.wave2EB160w].us,
        },
        // DELTA 2 Max
        [bundleKey.d2m220]: {
            webp: require(`@publicLocal/product-common/bundle-list/${d2m220_spec[locale] || d2m220_spec.us}.webp`),
            img: require(`@publicLocal/product-common/bundle-list/${d2m220_spec[locale] || d2m220_spec.us}.png`),
            name: t('bundle_d2m_220'),
            // @ts-ignore
            link: bundleLink[bundleKey.d2m220][locale] || bundleLink[bundleKey.d2m220].us,
        },
        [bundleKey.d2m400]: {
            webp: require(`@publicLocal/product-common/bundle-list/${d2m400_spec[locale] || d2m400_spec.us}.webp`),
            img: require(`@publicLocal/product-common/bundle-list/${d2m400_spec[locale] || d2m400_spec.us}.png`),
            name: t('bundle_d2m_400'),
            // @ts-ignore
            link: bundleLink[bundleKey.d2m400][locale] || bundleLink[bundleKey.d2m400].us,
        },
        [bundleKey.d2mPS]: {
            webp: require(`@publicLocal/product-common/bundle-list/d2m_ps.webp`),
            img: require(`@publicLocal/product-common/bundle-list/d2m_ps.png`),
            name: t('bundle_d2m_ps'),
            // @ts-ignore
            link: bundleLink[bundleKey.d2mPS][locale] || bundleLink[bundleKey.d2mPS].us,
        },
        [bundleKey.d2mWave2]: {
            webp: require('@publicLocal/product-common/bundle-list/d2m_wave2_us.webp'),
            img: require('@publicLocal/product-common/bundle-list/d2m_wave2_us.png'),
            name: t('bundle_d2m_wave2'),
            // @ts-ignore
            link: bundleLink[bundleKey.d2mWave2][locale] || bundleLink[bundleKey.d2mWave2].us,
        },
        [bundleKey.d2mWave2_au]: {
            webp: require('@publicLocal/product-common/bundle-list/d2m_wave2_au.png'),
            img: require('@publicLocal/product-common/bundle-list/d2m_wave2_au.png'),
            name: t('bundle_d2m_wave2'),
            // @ts-ignore
            link: bundleLink[bundleKey.d2mWave2_au].au,
        },
        [bundleKey.d2mEB]: {
            webp: require('@publicLocal/product-common/bundle-list/d2m_eb_eu.webp'),
            img: require('@publicLocal/product-common/bundle-list/d2m_eb_eu.png'),
            name: t('bundle_d2m_eb'),
            // @ts-ignore
            link: bundleLink[bundleKey.d2mEB][locale] || bundleLink[bundleKey.d2mEB].eu,
        },
        [bundleKey.d2mEC]: {
            webp: require('@publicLocal/product-common/bundle-list/d2m_ec.png'),
            img: require('@publicLocal/product-common/bundle-list/d2m_ec.png'),
            name: t('bundle_d2m_ec'),
            // @ts-ignore
            link: bundleLink[bundleKey.d2mEC][locale] || bundleLink[bundleKey.d2mEC].au,
        },
        [bundleKey.r2110]: {
            webp: 'https://br.ecoflow.com/cdn/shop/files/ecoflow-river-2-110w-portable-solar-panel-42462832787620_720x.png?v=1719297668',
            img: 'https://br.ecoflow.com/cdn/shop/files/ecoflow-river-2-110w-portable-solar-panel-42462832787620_720x.png?v=1719297668',
            name: 'Gerador Solar EcoFlow RIVER 2 (PV110W)',
            // @ts-ignore
            link: bundleLink[bundleKey.r2110][locale] || bundleLink[bundleKey.r2110].br,
        },
        [bundleKey.d2220]: {
            webp: 'https://br.ecoflow.com/cdn/shop/files/ecoflow-delta-2-220w-portable-solar-panel-42462812864676_720x.png?v=1719297687',
            img: 'https://br.ecoflow.com/cdn/shop/files/ecoflow-delta-2-220w-portable-solar-panel-42462812864676_720x.png?v=1719297687',
            name: 'Gerador Solar EcoFlow DELTA 2 (PV220W)',
            // @ts-ignore
            link: bundleLink[bundleKey.d2220][locale] || bundleLink[bundleKey.d2220].br,
        },
        [bundleKey.dp400]: {
            webp: 'https://br.ecoflow.com/cdn/shop/files/ecoflow-delta-pro-400w-portable-solar-panel-42462868471972_720x.png?v=1719297683',
            img: 'https://br.ecoflow.com/cdn/shop/files/ecoflow-delta-pro-400w-portable-solar-panel-42462868471972_720x.png?v=1719297683',
            name: 'Gerador Solar EcoFlow DELTA Pro (PV400W)',
            // @ts-ignore
            link: bundleLink[bundleKey.dp400][locale] || bundleLink[bundleKey.dp400].br,
        },
        [bundleKey.glacierdelta2]: {
            webp: require('@publicLocal/product-common/bundle-list/glacier-delta-max.webp'),
            img: require('@publicLocal/product-common/bundle-list/glacier-delta-max.png'),
            name: 'Estação de Energia Portátil EcoFlow DELTA 2 + Glacier',
            // @ts-ignore
            link: 'https://br.ecoflow.com/products/delta-2-portable-power-station?variant=49859456893224',
        },
        [bundleKey.glacierriver2pro220w]: {
            webp: require('@publicLocal/product-common/bundle-list/glacier-delta-max.webp'),
            img: require('@publicLocal/product-common/bundle-list/glacier-delta-max.png'),
            name: 'Estação de Energia Portátil EcoFlow RIVER 2 Pro',
            // @ts-ignore
            link: 'https://br.ecoflow.com/cdn/shop/files/ecoflow-us-ecoflow-river-2-pro-portable-power-station-standalone-river-2-pro-solar-generator-pv220w-33503727517769_720x_4e7a343a-1d57-4fe4-a432-672a2849354b_720x.webp?v=1733810675',
        },
        [bundleKey.river2max]: {
            webp: 'https://br.ecoflow.com/cdn/shop/files/ecoflow-us-ecoflow-river-2-max-portable-power-station-30042740555849_1500x_9a1c1573-86ee-4aa9-b74a-1f24c911fd2c_1500x.webp?v=1735116928',
            img: 'https://br.ecoflow.com/cdn/shop/files/ecoflow-us-ecoflow-river-2-max-portable-power-station-30042740555849_1500x_9a1c1573-86ee-4aa9-b74a-1f24c911fd2c_1500x.webp?v=1735116928',
            name: 'Estação de Energia Portátil EcoFlow RIVER 2 Max',
            link: 'https://br.ecoflow.com/products/river-2-max-portable-power-station',
        },
        [bundleKey.river2pro]: {
            webp: 'https://br.ecoflow.com/cdn/shop/files/ecoflow-us-ecoflow-river-2-pro-portable-power-station-30042784006217_1500x_854337f4-d338-4af3-84c4-03f1e06a5cc3_1500x.webp?v=1733810675',
            img: 'https://br.ecoflow.com/cdn/shop/files/ecoflow-us-ecoflow-river-2-pro-portable-power-station-30042784006217_1500x_854337f4-d338-4af3-84c4-03f1e06a5cc3_1500x.webp?v=1733810675',
            name: 'Estação de Energia Portátil EcoFlow RIVER 2 Pro',
            link: 'https://br.ecoflow.com/products/river-2-pro-portable-power-station',
        },
        [bundleKey.delta2]: {
            webp: 'https://br.ecoflow.com/cdn/shop/files/ecoflow-delta-2-portable-power-station-52097645347159_af9f1c9f-a8bb-42ef-b33b-bde856873c53_1500x.png?v=1718874086',
            img: 'https://br.ecoflow.com/cdn/shop/files/ecoflow-delta-2-portable-power-station-52097645347159_af9f1c9f-a8bb-42ef-b33b-bde856873c53_1500x.png?v=1718874086',
            name: 'Estação de Energia Portátil EcoFlow DELTA 2',
            link: 'https://br.ecoflow.com/products/delta-2-portable-power-station',
        },
    } as const;
    const handleClick = (key: keyof typeof bundleKey) => {
        saveAICookieForShopify(bundleMap[key].link, locale);

        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: bundleMap[key].name,
            position: 'Product Detail',
            __btn_id1: css.bundleList,
            __btn_id2: bundleMap[key].link,
        });
    };
    return (
        <div
            className={`GtmModuleData-section ${css.bundleList} ${isMobile ? 'bundle-list-h5' : 'bundle-list-pc'} theme-${theme}`}
            id="bundleList"
            data-section-id={css.bundleList}
            data-section-title={t('site_details_product_others')}
        >
            <div className="bundle-text-wrapper">
                <p>{t('site_details_product_others')}</p>
                <Link
                    className="view-more-link GtmModuleData-btn-href"
                    href={props.moreUrl}
                    ariaLabel={t('site_details_product_others')}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'view_more',
                        list_name: 'You might also like',
                        button_name: 'view_more',
                        __btn_id1: css.bundleList,
                        __btn_id2: props.moreUrl,
                    }}
                >
                    {t('site_details_product_view_more')}
                    <EFArrowRight />
                </Link>
            </div>
            <div className="bundle-list-box">
                {lists.map((key) => (
                    <div className="bundle-list-item" key={key}>
                        <div className="img-box">
                            <NextImage webpSrc={bundleMap[key].webp} src={bundleMap[key].img} alt={bundleMap[key].name} aria-label={bundleMap[key].name} />
                        </div>
                        <div className="bundle-name">{bundleMap[key].name}</div>
                        <Link
                            className="bundle-more-link GtmModuleData-btn-href"
                            href={bundleMap[key].link}
                            ariaLabel={bundleMap[key].name}
                            // dataLayer={{
                            //     event: 'uaEvent',
                            //     event_name: 'buy',
                            //     product_name: bundleMap[key].name,
                            //     position: 'Product Detail',
                            //     __btn_id1: css.bundleList,
                            //     __btn_id2: bundleMap[key].link,
                            // }}
                            onClick={() => handleClick(key)}
                        >
                            {t('common_learn_more')}
                            <EFArrowRight className="arrow-icon" />
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};
